'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQ {
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    question: 'Do you offer both 6-month and 12-month validity?',
    answer:
      'Yes. ParkPing Plus and ParkPing Prime are available in both 6-month and 12-month options. ParkPing Pro is custom for society and enterprise deployments.',
  },
  {
    question: 'What is the difference between Plus and Prime?',
    answer:
      'Both include parking SMS notification, private contact protection, and up to 15 alerts per plan. Prime additionally includes call details to the vehicle owner.',
  },
  {
    question: 'What is included in ParkPing Pro?',
    answer:
      'Pro includes all Prime features plus dedicated support. Pricing is custom based on society or enterprise requirements.',
  },
  {
    question: 'Can I switch from 6 months to 12 months later?',
    answer:
      'Yes. You can upgrade validity when renewing your plan.',
  },
  {
    question: 'Do you support bulk orders?',
    answer:
      'Yes. For housing societies and enterprise orders, choose ParkPing Pro and contact sales for custom pricing.',
  },
  {
    question: 'Is there any hidden fee?',
    answer:
      'No hidden charges. The price shown per card is the pricing for your selected validity period.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-heading font-bold text-gray-900 mb-2">Frequently Asked Questions</h3>
        <p className="text-sm text-gray-600">Everything you need to know about our plans and validity cycles</p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-white rounded-lg border border-gray-200 overflow-hidden transition-all duration-300 hover:border-[#42AF47]/30"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200"
            >
              <span className="text-base font-heading font-semibold text-gray-900 pr-4">{faq.question}</span>
              <Icon
                name="ChevronDownIcon"
                size={20}
                className={`text-[#42AF47] flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
              <div className="px-6 pb-5 pt-2">
                <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <p className="text-sm text-gray-600 mb-4">Still have questions?</p>
        <a
          href="/support-hub"
          className="inline-flex items-center space-x-2 text-[#42AF47] hover:text-[#42AF47]/80 font-medium transition-colors duration-200"
        >
          <span>Contact our support team</span>
          <Icon name="ArrowRightIcon" size={16} />
        </a>
      </div>
    </div>
  );
}
